import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../actions';
import logo from './hippalus2_LOGO_NEXT-small.png';

const { closeTab } = actions;

const Header = ({ location }) => {
  const dispatch = useDispatch();
  const { tabs } = useSelector(state => ({
    tabs: state.tabs
  }));

  const { pathname } = location;
  if (pathname === '/') return '';

  const isActive = routePath => ((routePath === pathname));
  const fnCloseTab = tId => () => dispatch(closeTab(tId));

  // eslint-disable-next-line react/prop-types
  const genTab = ({ tabId, routePath, eventKey, title }) => (
    <Nav.Item key={`navItem${tabId}`}>
      <Nav.Link className='closeButtonParrent' as={Link} to={routePath} eventKey={eventKey} active={isActive(routePath)}>
        <span>{title}</span>
        <span className='closeButton' onClick={fnCloseTab(tabId)}>x</span>
      </Nav.Link>
    </Nav.Item>
  );

  const renderTabs = () => Object.keys(tabs).map(
    tabID => tabs[tabID] ? genTab(tabs[tabID]) : ''
  );

  return (
    <Navbar bg='light' variant='light' style={{ boxShadow: '0px 3px 11px 2px rgba(0,0,0,0.1)', padding: 0 }}>
      <Navbar.Brand as={Link} to='/'>
        <img src={logo} width='110' height='30' className='d-inline-block align-top' alt='Hippalus' />
      </Navbar.Brand>
      <Nav className='mr-auto'>
        <Nav.Link as={Link} to='/datasets' active={isActive('/datasets')}>Datasets</Nav.Link>
        <Nav.Link as={Link} to='/readme' active={isActive('/readme')}>Read Me</Nav.Link>
      </Nav>
      <Nav variant='tabs'>
        {renderTabs()}
      </Nav>
    </Navbar>
  );

};

Header.propTypes = {
  // Redux
  tabs: PropTypes.shape({
    tabId: PropTypes.object,
  }).isRequired,
  // Router
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(Header);
